// extracted by mini-css-extract-plugin
export var grid = "ComponentImageTextGroup-module--grid--6b622";
export var gridItem = "ComponentImageTextGroup-module--gridItem--78153";
export var header = "ComponentImageTextGroup-module--header--9cdab";
export var heading = "ComponentImageTextGroup-module--heading--189e0";
export var media = "ComponentImageTextGroup-module--media--91df3";
export var paragraph = "ComponentImageTextGroup-module--paragraph--6ad8a";
export var section = "ComponentImageTextGroup-module--section--aad3b";
export var text = "ComponentImageTextGroup-module--text--f25cb";